function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillOpacity: 0.4,
  transform: "translate(55 42)"
}, /*#__PURE__*/React.createElement("g", {
  id: "snow-bottom-layer"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 6,
  cy: 91.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 138,
  cy: 110.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 398,
  cy: 55.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 719,
  cy: 284.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 760,
  cy: 155.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 635,
  cy: 159.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 478,
  cy: 235.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 322,
  cy: 214.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 247,
  cy: 234.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 154,
  cy: 25.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 731,
  cy: 273.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 599,
  cy: 74.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 339,
  cy: 19.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 239,
  cy: 4.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 113,
  cy: 63.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 102,
  cy: 223.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 395,
  cy: 155.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 826,
  cy: 43.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 626,
  cy: 54.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 887,
  cy: 66.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6,
  cy: 241.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 138,
  cy: 142.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 398,
  cy: 287.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 719,
  cy: 16.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 760,
  cy: 87.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 635,
  cy: 191.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 478,
  cy: 167.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 322,
  cy: 246.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 247,
  cy: 166.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 154,
  cy: 157.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 599,
  cy: 106.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 339,
  cy: 51.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 239,
  cy: 236.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 113,
  cy: 95.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 102,
  cy: 255.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 395,
  cy: 87.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 826,
  cy: 175.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 626,
  cy: 286.5,
  rx: 6,
  ry: 5.5
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 187,
  cy: 98.5,
  rx: 6,
  ry: 5.5
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff",
  fillOpacity: 0.6,
  transform: "translate(65 63)"
}, /*#__PURE__*/React.createElement("g", {
  id: "snow-top-layer"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 76,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 189,
  cy: 125,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 548,
  cy: 144,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 685,
  cy: 195,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 874,
  cy: 138,
  r: 8,
  transform: "rotate(180 874 1438)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 657,
  cy: 256,
  r: 8,
  transform: "rotate(180 657 1256)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 443,
  cy: 72,
  r: 8,
  transform: "rotate(180 443 1372)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 339,
  cy: 107,
  r: 8,
  transform: "rotate(180 339 1107)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 205,
  r: 8,
  transform: "rotate(180 24 1305)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 189,
  cy: 157,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 548,
  cy: 76,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 685,
  cy: 147,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 858,
  cy: 141,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 874,
  cy: 70,
  r: 8,
  transform: "rotate(180 874 670)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 657,
  cy: 288,
  r: 8,
  transform: "rotate(180 657 488)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 443,
  cy: 194,
  r: 8,
  transform: "rotate(180 443 604)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 339,
  cy: 239,
  r: 8,
  transform: "rotate(180 339 339)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 137,
  r: 8,
  transform: "rotate(180 24 537)"
})));

function SvgFirefly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 325",
    preserveAspectRatio: "xMidYMax slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefly);
export default __webpack_public_path__ + "static/media/firefly.22ef1f8a.svg";
export { ForwardRef as ReactComponent };